import { authPost } from "@api";
import { AUTH_URL } from "@constants";
import { SsoProviderSettings } from "@types";

import { EnableSsoProviderResponse } from "@pages/settings/types";

export const enableSsoProvider = (
  ssoSettings: SsoProviderSettings
): Promise<EnableSsoProviderResponse> => {
  const url = `${AUTH_URL}/providers`;
  return authPost<SsoProviderSettings, EnableSsoProviderResponse>(
    url,
    ssoSettings
  );
};
